import React from 'react'
import {Container, Row, Col, Navbar, Nav} from 'react-bootstrap'
import FormInput from 'components/componentsmall/form_input'
import Input from 'components/dashboard/input'
import './style.css'
import {Link} from 'react-router-dom'

export default function jumbotron() {
    return (
        <div className="toko_reseller_jumbotron">    
        <Navbar>
            <Container>
            <Input cGroup="reseller-serach" placeholder="Cari barang ..." />
                <Nav className="me-auto">
                    {
                        Icons.map((icon, i) => {
                            return (
                                <div key={i} className="icons">
                                   <Link to={icon.link}><img src={icon.src} alt="icon" /></Link>
                                </div>
                            )
                        })
                    } 
                </Nav>
            </Container>
        </Navbar>
            <Container>
                <Row>
                    <Col md={8}>
                        <h3>Selamat Datang</h3>
                        <div className="profile_toko">
                           <h4>Toko Muhammad Rifqi Mubarak</h4> 
                            <div className="start">
                                {
                                    Start.map((icon, i) => {
                                        return ( 
                                            <img key={i} src={icon.src} alt="start" />
                                        )
                                    })
                                }
                                <div className="whatsapp">
                                <a href="https:wa.me/+6285349780521" target="_blank" rel="noopener noreferrer">
                                    <FormInput
                                    cName="input" type="button"
                                    value="Hubungi Penjual"
                                    cImg="icon-watshapp"
                                    src="asset/Toko_Reseller/whatsapp.svg"
                                    alt="whatsapp"
                                />
                                </a>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

const Icons = [
    {src:"asset/toko_reseller/card.svg", link:"#"},
    {src:"asset/toko_reseller/user.svg", link:"ber_akun"}
]

const Start = [
    {src:"asset/toko_reseller/start.svg"},
    {src:"asset/toko_reseller/start.svg"},
    {src:"asset/toko_reseller/start.svg"},
    {src:"asset/toko_reseller/start.svg"},
    {src:"asset/toko_reseller/start.svg"}
 
]
